import React from 'react';
import type { BundleId } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { bundleName, formatMoney, getBundle, priceBundle, upgradeTarget } from '../../utils/pricing';
import { buttonClasses } from '../../utils/buttonStyles';
import { WarrantyTag } from '../ui/WarrantyTag';
type UpgradeOfferProps = {
  bundleId: BundleId;
  onAccept: () => void;
  onDecline: () => void;
};
export function UpgradeOffer({
  bundleId,
  onAccept,
  onDecline
}: UpgradeOfferProps) {
  const {
    lang
  } = useLanguage();
  const current = getBundle(bundleId);
  const target = upgradeTarget(bundleId);
  if (!target) return null;
  const cp = priceBundle(current);
  const tp = priceBundle(target);
  const diff = Math.round((tp.total - cp.total) * 100) / 100;
  const addedLights = target.qty - current.qty;
  const perAdded = Math.round(diff / addedLights * 100) / 100;
  return <div data-id="element-876" data-mp="3uwplehyxfsni">
      <h2 id="funnel-title" className="mt-3 font-display text-4xl font-semibold uppercase leading-none md:text-5xl" data-id="element-877" data-mp="3uwfveudvtlht">
        Go further with the {bundleName(target, lang)}
      </h2>
      <p className="mt-4 text-titanium" data-id="element-878" data-mp="1kkenjkbhemim">
        {addedLights} more M1 PRO lights for {formatMoney(diff, lang)} more — that's {formatMoney(perAdded, lang)} per added
        light.
      </p>

      <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-xl border mf-hairline bg-white/10" data-id="element-879" data-mp="1u96blhdf8mo9">
        {[{
        b: current,
        p: cp,
        label: 'Your selection'
      }, {
        b: target,
        p: tp,
        label: 'Upgrade'
      }].map(({
        b,
        p,
        label
      }, i) => <div key={b.id} className={`flex flex-col p-5 md:p-6 ${i === 1 ? 'bg-[#0F2A47]' : 'bg-navy'}`} data-id="element-880" data-mp="1gi1lb5vy16ql" data-mpi={i}>
            <span className="text-xs uppercase tracking-[0.12em] text-titanium/70" data-id="element-881" data-mp="1bj85h6t6p3n9">{label}</span>
            <span className="mt-2 font-display text-5xl font-semibold leading-none" data-id="element-882" data-mp="2rwyacfs4nvxy">{b.qty}</span>
            <span className="text-sm text-titanium" data-id="element-883" data-mp="2my3r5cq905db">lights</span>
            <span className="mt-4 text-xl font-semibold" data-id="element-884" data-mp="2mxu3hvsoeaas">{formatMoney(p.total, lang)}</span>
            <span className="text-sm text-titanium" data-id="element-885" data-mp="2u0sakx3d1ta2">{formatMoney(p.perUnit, lang)} per light</span>
            <div className="mt-4" data-id="element-886" data-mp="2yytsvfsypokh">
              <WarrantyTag tier={b.warranty} data-id="element-887" data-mp="33zhq4j7sb1n5" />
            </div>
          </div>)}
      </div>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-888" data-mp="38ykip46kvfe8">
        <button type="button" onClick={onAccept} className={`${buttonClasses('primary')} flex-1`} data-id="element-889" data-mp="38xt14x9tfi6y">
          Upgrade to {target.qty} lights
        </button>
        <button type="button" onClick={onDecline} className={`${buttonClasses('secondary')} flex-1`} data-id="element-890" data-mp="2g9dky7ey6tu1">
          Keep {current.qty} lights
        </button>
      </div>
    </div>;
}